module.exports = __webpack_public_path__ + "media/bg-video.1bd789c1.mp4";